import { apiGeEmInfo, apiGetPayOrderList, apiCancelWaitOrder } from '@/api';
import { showToast, showConfirm, } from '@/utils/utils';
import { PayOrderStatus } from '@/utils/dict'

/** 待支付订单弹窗的弹出场景 */
export enum WaitOrderSense {
    // 购买套餐等
    Buy = 'buy',
    // 支付订单
    Pay = 'pay'

}
export interface waitOrderDetectProps {
    sense: WaitOrderSense
}
const tipsContentBySense = {
    [WaitOrderSense.Buy]: '存在待支付订单，请点击关闭待支付订单后订购套餐~',
    [WaitOrderSense.Pay]: '存在待支付订单，请点击关闭待支付订单后支付订单~',
};


// 获取设备信息
async function getEmInfo() {
    try {
        const emInfoRes = await apiGeEmInfo();
        if (emInfoRes?.data?.code === 200) {
            return emInfoRes.data.data;
        } else {
            showToast(emInfoRes?.data?.msg || '设备号获取失败');
            return null;
        }
    } catch (error) {
        console.log('获取设备信息出错:', error);
        return null;
    }
};

// 获取待支付订单列表
async function getWaitOrderList(emNumber: string) {
    try {
        const waitOrderInfo = await apiGetPayOrderList('', {
            orderByColumn: undefined,
            isAsc: undefined,
            emId: undefined,
            emNumber,
            status: PayOrderStatus.wait,
        });
        return waitOrderInfo?.data?.rows || [];
    } catch (error) {
        console.log('获取待支付订单列表出错:', error);
        return [];
    }
};

// 关闭待支付订单
async function cancelWaitOrders(waitOrderList: { id: string }[]) {
    try {
        const results = await Promise.all(waitOrderList.map((item) => apiCancelWaitOrder(item.id)));
        const hasError = results.some((i) => i?.data?.code !== 200);
        if (!hasError) {
            showToast('待支付订单关闭成功~');
            return true;
        } else {
            showToast('待支付订单关闭失败！');
            return false;
        }
    } catch (error) {
        console.log('关闭待支付订单出错:', error);
        return false;
    }
}

export async function waitOrderDetect(props: waitOrderDetectProps) {
    const { sense } = props;
    const currentEm = await getEmInfo();
    if (!currentEm) {
        return false;
    }

    const waitOrderList = await getWaitOrderList(currentEm.emNumber);
    if (waitOrderList.length === 0) {
        return true;
    }

    const clickRes = await showConfirm({
        title: '待支付订单提醒',
        content: tipsContentBySense[sense],
        confirmBtnText: '关闭待支付订单',
        hideCancelBtn: true,
    });
    if (clickRes) {
        return await cancelWaitOrders(waitOrderList);
    }
    return false;
}